let surveyLoaded = null;

const SURVEY_CDN_BASE = 'https://cdn.jsdelivr.net/npm/survey-jquery@1.1.18';
const SURVEY_JS_URL = `${SURVEY_CDN_BASE}/survey.jquery.min.js`;
const SURVEY_CSS_URL = `${SURVEY_CDN_BASE}/survey.min.css`;

function loadScript(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
    document.head.appendChild(script);
  });
}

function loadStylesheet(url) {
  return new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.onload = resolve;
    link.onerror = () => reject(new Error(`Failed to load stylesheet: ${url}`));
    document.head.appendChild(link);
  });
}

export async function loadSurvey() {
  if (!surveyLoaded) {
    surveyLoaded = Promise.all([
      loadStylesheet(SURVEY_CSS_URL),
      loadScript(SURVEY_JS_URL)
    ]).then(() => {
      if (typeof window.Survey === 'undefined') {
        throw new Error('Survey library failed to initialize');
      }
      return window.Survey;
    });
  }
  return surveyLoaded;
}

export async function initializeSurvey(surveyJson) {
  const Survey = await loadSurvey();
  return new Survey.Model(surveyJson);
}
